import React from "react";
import { FromInt } from "../../helpers/NumberTools";

//icon
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PhoneIcon from "@mui/icons-material/Phone";
import ApprovalIcon from "@mui/icons-material/Approval";
import PersonIcon from "@mui/icons-material/Person";

const AddressCard = (props) => {
  const { address } = props;
  return (
    <div className="row cards">
      <div className="col-12">
        <PersonIcon className="m-1" /> {FromInt(`${address.recipientsName}`)}
      </div>
      <div className="col-12 ">
        <LocationOnIcon className="m-1" />{" "}
        {FromInt(`${address.Province.name} - ${address.City} - ${address.recipientsAddress}`)}
      </div>
      <div className="col-12 ">
        <ApprovalIcon className="m-1" /> {FromInt(`${address.postalCode}`)}
      </div>
      <div className="col-12 ">
        <PhoneAndroidIcon className="m-1" /> {FromInt(`${address.recipientsMobiles}`)}
      </div>
      <div className="col-12  ">
        <PhoneIcon className="m-1" /> {FromInt(`${address.recipientsPhone}`)}
      </div>
    </div>
  );
};

export default AddressCard;
